// PageVisibilityHandler.js
'use strict';
import { connect } from 'react-redux';

import PageVisibilityHandler from '../component/PageVisibilityHandler.jsx';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

const mapDispatchToProps = dispatch => {
  return {
    setIsBrowserTabVisible: ({ isBrowserTabVisible }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['visibility'],
          data: {
            isBrowserTabVisible,
          },
        },
      }),
  };
};

export default connect(null, mapDispatchToProps)(PageVisibilityHandler);
